const legacySeoHosts = new Set(['attendin.io', 'www.attendin.io', 'localhost', '127.0.0.1']);

function trimTrailingSlash(url: string): string {
    return url.replace(/\/+$/, '');
}

function normaliseRoutePath(routePath: string): string {
    if (!routePath || routePath === '/') {
        return '';
    }

    return routePath.startsWith('/') ? routePath : `/${routePath}`;
}

function getConfiguredSiteUrl(): string | undefined {
    const configured = import.meta.env.VITE_SITE_URL;
    if (typeof configured !== 'string') {
        return undefined;
    }

    const trimmed = configured.trim();
    return trimmed.length > 0 ? trimTrailingSlash(trimmed) : undefined;
}

function getRuntimeOrigin(): string | undefined {
    if (typeof window === 'undefined') {
        return undefined;
    }

    return trimTrailingSlash(window.location.origin);
}

export function getSeoSiteUrl(): string {
    return getConfiguredSiteUrl() ?? getRuntimeOrigin() ?? 'https://attendin.io';
}

export function toSeoCanonicalUrl(urlOrPath: string): string {
    const siteUrl = getSeoSiteUrl();

    if (!urlOrPath) {
        return siteUrl;
    }

    if (/^https?:\/\//i.test(urlOrPath)) {
        try {
            const parsedUrl = new URL(urlOrPath);
            return `${siteUrl}${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
        } catch {
            return `${siteUrl}${normaliseRoutePath(urlOrPath)}`;
        }
    }

    return `${siteUrl}${normaliseRoutePath(urlOrPath)}`;
}

export function toSeoAbsoluteUrl(urlOrPath: string): string {
    const siteUrl = getSeoSiteUrl();

    if (!urlOrPath) {
        return siteUrl;
    }

    if (/^https?:\/\//i.test(urlOrPath)) {
        try {
            const parsedUrl = new URL(urlOrPath);
            const hostname = parsedUrl.hostname.toLowerCase();

            if (legacySeoHosts.has(hostname)) {
                return `${siteUrl}${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
            }

            return urlOrPath;
        } catch {
            return urlOrPath;
        }
    }

    return `${siteUrl}${normaliseRoutePath(urlOrPath)}`;
}
